// extracted by mini-css-extract-plugin
module.exports = {"root":"AvatarGroup_root__BlH32","avatar":"AvatarGroup_avatar___EwWK","img":"AvatarGroup_img__Oz0Rj","avatarAttended":"AvatarGroup_avatarAttended__oiNmo"};